export const PREFIX_AUTOMATED = 'Automated';
export const PREFIX_LIVE = 'Live';
